export enum ProjectLogoMapEnum {
  SocialiteEvents = './assets/images/logo/socialite-logo.png',
  SocialitePOS = './assets/images/logo/socialite-pos-logo.png',
  SocialiteResy = './assets/images/logo/socialite-resy-logo.png'
}
